import {
    createContext,
    useContext,
    ReactElement,
    PropsWithChildren
} from "react";

import { ITrelloClient, TrelloClient } from "../../client";
import { stubTrelloClient } from "../../client/stubs";

const defaultClient =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1")
        ? stubTrelloClient()
        : new TrelloClient();

export const TrelloClientContext = createContext<ITrelloClient>(defaultClient);

export type TrelloClientProviderProps = {
    readonly client: ITrelloClient;
};

export const TrelloClientProvider = ({
    client,
    children
}: PropsWithChildren<TrelloClientProviderProps>): ReactElement => {
    return (
        <TrelloClientContext.Provider value={client}>
            {children}
        </TrelloClientContext.Provider>
    );
};

export function useTrelloClient() {
    return useContext(TrelloClientContext);
}
